import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from 'vue';

interface IProps {
  text: string;
  color: string;
  bgColor: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomBadge',
  props: {
    text: null,
    color: { default: '#15D05' },
    bgColor: { default: '#ccffee' }
  },
  setup(__props: any) {

const props = __props as { text: string, color: string, bgColor: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", {
    style: _normalizeStyle({ background: __props.bgColor, color: __props.color }),
    class: "badge"
  }, [
    _renderSlot(_ctx.$slots, "icon"),
    _createTextVNode(" " + _toDisplayString(props.text), 1)
  ], 4))
}
}

})